import styled from "styled-components";
import { Button } from "../../../../../base/buttons/button/index.js";
import Image from "../../../../../base/multimedia/image/index.js";
import { ImageStyled } from "../../../../../base/multimedia/image/styled.js";
import { FlexMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const ProductsBannerContainer = styled.div.withConfig({
    displayName: "styled__ProductsBannerContainer",
    componentId: "sc-3ec0ab41-0"
})`
	${FlexMixin({
    justify: 'space-between',
    align: 'flex-end'
})}
	position: relative;
	margin: 0 auto;
	max-width: 1500px;
	width: 100%;
	padding: 0 20px;

	& > a > ${ImageStyled} {
		width: 500px;
		height: 375px;
	}
`;
export const ProductsBannerContent = styled.div.withConfig({
    displayName: "styled__ProductsBannerContent",
    componentId: "sc-3ec0ab41-1"
})`
	${FlexMixin({
    direction: 'column',
    align: 'flex-start'
})}
	width: 100%;
`;
export const ProductsBannerHeader = styled.div.withConfig({
    displayName: "styled__ProductsBannerHeader",
    componentId: "sc-3ec0ab41-2"
})`
	text-align: center;
	width: 100%;
`;
export const ProductsBannerOrigins = styled.div.withConfig({
    displayName: "styled__ProductsBannerOrigins",
    componentId: "sc-3ec0ab41-3"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin-bottom: 16px;
	text-align: center;
	width: 100%;

	${Button} {
		margin-left: 16px;
	}
`;
export const ProductsList = styled.div.withConfig({
    displayName: "styled__ProductsList",
    componentId: "sc-3ec0ab41-4"
})`
	${FlexMixin({
    wrap: true
})}
`;
export const ProductBannerImage = styled(Image).withConfig({
    displayName: "styled__ProductBannerImage",
    componentId: "sc-3ec0ab41-5"
})`
	margin-left: auto;
	margin-bottom: 20px;

	@media (max-width: ${(props)=>props.theme.breakpoints.xl}px) {
		display: none;
	}
`;

//# sourceMappingURL=styled.js.map